import React, { Component } from "react";
import { buttonSize, EMPTY_STRING, fields } from "../../constants";
import AHAlphaField from "../../../AHAlphaField";
import { MAX_EMAIL_LENGTH } from "../../../../../../constants";
import AHButton from "../../../AHButton";
import PropTypes from "prop-types";
import { PasswordRequirements } from "../PasswordRequirements";
import { areAllRequirementsMet } from "../../helpers";

class TableView extends Component {
    render() {
        const allRequirementsMet = areAllRequirementsMet(
            this.props.newPassword
        );

        return (
            <>
                <tr>
                    <td className="w-2/5">{fields.NEW_PASSWORD}</td>
                    <td className="w-3/5">
                        <div className="group relative">
                            <AHAlphaField
                                label={fields.NEW_PASSWORD}
                                value={this.props.newPassword}
                                placeholder={this.props.newPasswordPlaceholder}
                                id={this.props.newPasswordId}
                                type={"password"}
                                maxLength={MAX_EMAIL_LENGTH}
                                showLabel={false}
                                onChange={this.props.onChange}
                            />
                            {!allRequirementsMet && (
                                <div className="tw-rounded-sm absolute top-full left-0 z-10 mt-[15px] hidden w-[300px] bg-white p-[10px] pt-[25px] shadow-[0_2px_8px_rgba(0,0,0,0.15)] group-hover:block hover:block">
                                    {/* Create a unified arrow that's part of the hover box */}
                                    <div className="absolute top-[-6px] left-[15px] z-1 h-[14px] w-[14px] rotate-45 bg-white shadow-[-2px_-2px_4px_rgba(0,0,0,0.05)]"></div>
                                    <PasswordRequirements
                                        password={this.props.newPassword}
                                    />
                                </div>
                            )}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td className="w-2/5">{fields.PASSWORD_CONFIRMATION}</td>
                    <td className="w-3/5">
                        <AHAlphaField
                            label={fields.PASSWORD_CONFIRMATION}
                            value={this.props.confirmPassword}
                            placeholder={this.props.confirmPasswordPlaceholder}
                            id={this.props.confirmPasswordId}
                            type={"password"}
                            maxLength={MAX_EMAIL_LENGTH}
                            showLabel={false}
                            onChange={this.props.onChange}
                        />
                    </td>
                </tr>
                <tr>
                    <td className="w-2/5"></td>
                    <td className="w-3/5">
                        <AHButton
                            id="reset-pwd-submit-btn"
                            className={"password-submit"}
                            onClick={this.props.onSubmit}
                            isOutline={false}
                            isSecondary={false}
                            isDynamic={false}
                            size={buttonSize.LARGE}
                            text={fields.PASSWORD_SUBMIT}
                        />
                    </td>
                </tr>
            </>
        );
    }
}

TableView.propTypes = {
    newPassword: PropTypes.string,
    confirmPassword: PropTypes.string,
    userData: PropTypes.object,
    onChange: PropTypes.func,
    onSubmit: PropTypes.func,
    newPasswordId: PropTypes.string,
    confirmPasswordId: PropTypes.string,
    newPasswordPlaceholder: PropTypes.string,
    confirmPasswordPlaceholder: PropTypes.string,
};

TableView.defaultProps = {
    newPassword: EMPTY_STRING,
    confirmPassword: EMPTY_STRING,
    userData: {},
    newPasswordPlaceholder: EMPTY_STRING,
    confirmPasswordPlaceholder: EMPTY_STRING,
};

export default TableView;
